export default {
    validation: {
        required: '必填',
        invalidEmailFormat: '电子邮箱格式错误'
    }
};
